// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2HUoD","info":"PatientInfo_info__2Ev5S"};